import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bookmark--sprite",
  "use": "bookmark--sprite-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol viewBox=\"0 0 25 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"bookmark--sprite\">\n<path d=\"M16.5 11V17.97L11.5 15.83L6.5 17.97V5H12.5V3H6.5C5.4 3 4.5 3.9 4.5 5V21L11.5 18L18.5 21V11H16.5ZM20.5 7H18.5V9H16.5V7H14.5V5H16.5V3H18.5V5H20.5V7Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol